export const LOADING = "LOADING"
export const RESULT = "RESULT"

export const INITCONFIG = "PROJECT_CONFIG_INITCONFIG"
